<div
  *ngFor="let alert of visibleAlerts"
  [ngClass]="alert.background_color + (alert.elevation ? ' mat-elevation-z1' : '')"
  style="
    width: 100%;
    justify-content: space-between;
    align-items: center;
    min-height: 48px;
  "
  class="flex-row"
>
  <div
    style="padding-left: 16px; align-items: center"
    class="flex-row"
    [style.color]="alert.message_color"
  >
    <mat-icon [style.color]="alert.message_color">{{ alert.icon }}</mat-icon>
    <div style="font-size: 14px; padding-left: 16px">
      {{ getLocalized(alert.message) }}
    </div>
    <div
      style="padding-left: 16px"
      *ngIf="alert.message_url && getLocalized(alert.message_url_label)"
      class="h3"
    >
      <a
        href="{{ alert.message_url }}"
        target="{{ alert.message_url_target || '_blank' }}"
        >{{ getLocalized(alert.message_url_label) }}</a
      >
    </div>
  </div>

  <div *ngIf="alert.message_closable">
    <button
      mat-icon-button
      matTooltip="{{ 'GENERIC.CANCEL' | translate }}"
      (click)="onHideAlert(alert)"
      [style.color]="alert.message_color"
    >
      <mat-icon [style.color]="alert.message_color">{{
        iconsService.getIcon("CANCEL")
      }}</mat-icon>
    </button>
  </div>
</div>
